import { createRoot } from "react-dom/client";
import React from "react";
import { InteractiveTableFilter } from "~assets/frontend/components/comp-interactive_table_filter/InteractiveTableFilter";
const updateTableRows = (selectedRows, scope) => {
    const rows = scope.querySelectorAll(`[data-id]`);
    if (selectedRows.length === 0 || rows.length === selectedRows.length) {
        rows.forEach((row) => {
            row.classList.remove("hidden");
        });
    }
    else {
        rows.forEach((row) => {
            const id = row.getAttribute("data-id");
            if (id) {
                if (selectedRows.indexOf(id) !== -1) {
                    row.classList.remove("hidden");
                }
                else {
                    row.classList.add("hidden");
                }
            }
        });
    }
};
export const InteractiveTableLoader = (triggers) => {
    triggers.forEach((triggerElement) => {
        const filterElement = triggerElement.querySelector("[data-filter]");
        const jsData = filterElement === null || filterElement === void 0 ? void 0 : filterElement.getAttribute("data-filter");
        if (typeof jsData === "string") {
            // @ts-ignore
            const data = window[jsData];
            if (data instanceof Map && filterElement) {
                const root = createRoot(filterElement);
                root.render(React.createElement(InteractiveTableFilter, { id: "i", data: data, onUpdate: (rowIdentifiers) => {
                        updateTableRows(rowIdentifiers, triggerElement);
                    } }));
            }
        }
    });
};
